export default "/kiban/_next/static/images/1clickButton-fd367cb9b7515fea6b440b1418fdb92f.png";